import React from 'react';
import ReactDOM from 'react-dom';
import {Home} from './pages/home';
import {Login} from './pages/login';
import {apiVariables} from './utils/variables'
import {BrowserRouter as Router} from 'react-router-dom';


//Imported styles
import './index.css';
import './main.css';
import './includes/bootstrap-3.3.7/css/bootstrap.min.css';
/* eslint eqeqeq: "off"*/

async function checkLogin(){
    console.log(apiVariables.apiLink + "user")
    return fetch(
        apiVariables.apiLink + "user", {
            method: "GET",
            credentials: apiVariables.credentials,
            headers: apiVariables.headers
        }
    ).then((res)=>{
        if(res.status === 200){
            return {loggedIn: true, user: res.statusText, pending: false}
        }
        else{
            return {loggedIn: false, user: "", pending: false}
        }
    })
}
class Container extends React.Component{
    constructor(props){
        super(props)
        this.state = {loggedIn: false, user: "", pending: true}

    }
    async componentWillMount(){
        this.setState(await checkLogin())
    }
    render(){
        return(
        <Router>
            {!this.state.pending ? <div>
                {this.state.loggedIn ? <Home signout={() => {this.setState({loggedIn: false})}} username={this.state.user} /> : <Login login={() => this.setState({loggedIn: true, pending: false})} />}
            </div> : null}
        </Router>)
        
    }
    
    
}

ReactDOM.render(
    <Container />,
    document.getElementById('app')
  );
  


// WEBPACK FOOTER //
// ./src/index.js